export default {
  stepTitle: {
    id: 'address_book_rules_all_markets_title_new',
    defaultMessage: 'Markets selection',
  },
  allMarketsLabel: {
    id: 'address_book_rules_all_markets_label',
    defaultMessage: 'All markets',
  },
  allMarketsDescription: {
    id: 'address_book_rules_all_markets_description',
    defaultMessage: 'All current and future markets',
  },
  someMarketsTitle: {
    id: 'address_book_rules_some_markets_title',
    defaultMessage: 'or select markets one by one',
  },
  cta: {
    id: 'address_book_rules_cta',
    defaultMessage: 'Save and continue',
  },
}
